import React from 'react'
import { requestSelection } from 'services/CurrentAwarenessService'
import connect from 'components/shared/connect'
import { mapResponse } from 'front-end-core/helpers/dataflow'
import { map } from 'rxjs/operators'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'

const Wrapper = ({ group }) => {
  const cxNames = {
    accordionContainer: 'layout-width-container mb6',
    groupHeader: {
      depthStyle: () => {
        return 'bg-white black b--light-sea-green-2'
      },
      iconDepthStyle: depth => {
        switch (depth) {
          case 2:
            return 'white'
          default:
            return 'black o-80'
        }
      }
    },
    contentHeader: {
      borderColor: 'b--light-sea-green-2',
      headerBackground: 'bg-ghost-grey'
    },
    content: {
      divider: 'bt--light-sea-green-2'
    },
    borderColor: 'b--light-sea-green-2'
  }

  return (
    <div className='layout-width-constraint'>
      <AccordionWrapperContainer
        {...{ cxNames, group }}
        title={null}
        eventCategory='CA'
        showAllS1
        SectionHeaderOverride={() => null}
        styleTitle={false}
        contained
      />
    </div>
  )
}

export default connect(
  ({ flavour, selectedIds, aol }) => requestSelection(flavour, selectedIds, aol).pipe(map(mapResponse(group => ({ group }))))
)(Wrapper)
